import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MatchesStore from '../../stores/MatchesStore';
import MatchesActionCreators from '../../actions/MatchesActionCreators';
import VoteButtons from '../../components/matches/VoteButtons';

class ProfileVotesContainer extends Component {
  state = {
    vote: null,
    loading: false,
    noAboLimitReached: this.props.noAboLimitReached,
    hasMatch: false,
  };

  componentDidMount() {
    const {
      isLiked, isDisliked, noAboLimitReached, hasMatch,
    } = this.props;
    let vote = null;
    if (isLiked) {
      vote = 'like';
    } else if (isDisliked) {
      vote = 'dislike';
    }

    this.setState({ vote, hasMatch });
    MatchesStore.setProfileVote(vote);

    MatchesStore.setNoAboLimitReached(noAboLimitReached);

    MatchesStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    MatchesStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      vote: MatchesStore.getProfileVote(),
      loading: MatchesStore.getLoading(),
      noAboLimitReached: MatchesStore.getNoAboLimitReached(),
    });
  };

  handleVote = (newVote) => {
    const { memberId } = this.props;

    MatchesStore.setLoading(true);
    MatchesStore.emitChange();

    MatchesActionCreators.matchesVote(memberId, newVote);
  };

  getText = (hasMatch) => {
    if (hasMatch && this.state.vote === 'like') {
      return (
        <div>
          <p className="tcg title"><b>Jums ir saderība!</b></p>
          <p>Jūs abi viens otram patīkat :)</p>
        </div>
      );
    }
    return (
      <div>
        <p className="title"><b>Vai jums ir saderība!?</b></p>
        <p>
          Ja abi viens otram nospiedīsiet &quot;Man patīk!&quot;, redzēsiet viens otru sadaļā
          <a className="tcb tdn" href="/matches">Saderības</a>
        </p>
      </div>
    );
  };

  render() {
    const {
      vote,
      loading,
      noAboLimitReached,
      hasMatch,
    } = this.state;

    console.log('vote', vote);

    return (
      <div className={`mbl${loading ? ' loading' : ''}`}>
        { this.getText(hasMatch) }

        <VoteButtons
          onVote={this.handleVote}
          active={vote}
          noAboLimitReached={noAboLimitReached}
          noShadow
        />
      </div>
    );
  }
}

ProfileVotesContainer.propTypes = {
  memberId: PropTypes.string,
  isLiked: PropTypes.bool,
  isDisliked: PropTypes.bool,
  noAboLimitReached: PropTypes.bool,
  hasMatch: PropTypes.bool,
};

ProfileVotesContainer.defaultProps = {
  memberId: null,
  isLiked: false,
  isDisliked: false,
  noAboLimitReached: false,
  hasMatch: false,
};

export default ProfileVotesContainer;
